import { render, staticRenderFns } from "./ProposalAssetsView.vue?vue&type=template&id=48708d9a&scoped=true&"
import script from "./ProposalAssetsView.vue?vue&type=script&lang=js&"
export * from "./ProposalAssetsView.vue?vue&type=script&lang=js&"
import style0 from "./ProposalAssetsView.vue?vue&type=style&index=0&id=48708d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48708d9a",
  null
  
)

export default component.exports